import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/app/Home.vue'
import Login from './views/auth/Login.vue'
import Postos from './views/app/Postos'
import Bandeiras from './views/app/Bandeiras'
import Categorias from './views/app/Categorias'
import Automacao from './views/app/Automacao'
import FormasPagamento from './views/app/FormasPagamento'
import TiposPagamento from './views/app/TiposPagamento'
import Clientes from './views/app/Clientes'
import Usuarios from './views/app/Usuarios'
import Compras from './views/app/Compras'
import Vouchers from './views/app/Vouchers'
import Faq from './views/app/Faq'
import Versionamento from './views/app/Versoes'
import AuthHandle from './views/auth/AuthHandle'
import TermosUsoPoliticas from './views/app/TermosUsoPoliticas'
import PagamentosExtra from './views/app/PagamentosExtra'
import Faturamentos from './views/app/Faturamentos'
import Configuracoes from './views/app/Configuracoes'
import Notificacoes from './views/app/Notificacoes'
import Empresas from './views/app/Empresas'
import Convenios from './views/app/Convenios'
import Relatorio from './views/app/Relatorio'
import MeiosDeRecebimento from './views/app/MeiosDeRecebimento'
import Negociacoes from './views/app/Negociacoes'
import CarteiraVirtual from './views/app/CarteiraVirtual'
import Veiculos from './views/app/Veiculos'
import Anuncios from './views/app/Anuncios'
import RelatorioDividasCashPosto from './views/app/RelatorioDividasCashPosto'
import Redes from './views/app/Redes.vue'
import RelatorioLeiloes from './views/app/RelatorioLeiloes.vue'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: '/',
  routes: [
    {
      path: '/',
      name: 'login',
      component: Login
    },
    {
      path: '/auth',
      component: AuthHandle,
      props: (route) => ({
        mode: route.query.mode,
        oobCode: route.query.oobCode,
        apiKey: route.query.apiKey,
        lang: route.query.lang
      })
    },
    {
      path: '/home',
      component: Home,
      children: [
        {
          path: '',
          component: Postos
        },
        {
          path: '/carteiravirtual',
          component: CarteiraVirtual
        },
        {
          path: '/bandeiras',
          component: Bandeiras
        },
        {
          path: '/categorias',
          component: Categorias
        },
        {
          path: '/formaspag',
          component: FormasPagamento
        },
        {
          path: '/tipospag',
          component: TiposPagamento
        },
        {
          path: '/meiosderecebimento',
          component: MeiosDeRecebimento
        },
        {
          path: '/negociacoes',
          component: Negociacoes
        },
        {
          path: '/automacao',
          component: Automacao
        },
        {
          path: '/clientes',
          component: Clientes
        },
        {
          path: '/relatorio',
          component: Relatorio,
          children: [
            {
              path: '/relatorio/compras',
              component: Compras
            },
            {
              path: '/relatorio/vouchers',
              component: Vouchers
            },
            {
              path: '/relatorio/dividas-apetrus',
              component: RelatorioDividasCashPosto
            },
            {
              path: '/relatorio/leiloes',
              component: RelatorioLeiloes
            }
          ]
        },
        {
          path: '/usuarios',
          component: Usuarios
        },
        {
          path: '/faq',
          component: Faq
        },
        {
          path: '/versionamento',
          component: Versionamento
        },
        {
          path: '/termospoliticas',
          component: TermosUsoPoliticas
        },
        {
          path: '/pagamentosextras',
          component: PagamentosExtra
        },
        {
          path: '/faturamentos',
          component: Faturamentos
        },
        {
          path: '/configuracoes',
          component: Configuracoes
        },
        {
          path: '/notificacoes',
          component: Notificacoes
        },
        {
          path: '/empresas',
          component: Empresas
        },
        {
          path: '/convenios',
          component: Convenios
        },
        {
          path: '/veiculos',
          component: Veiculos
        },
        {
          path: '/anuncios',
          component: Anuncios
        },
        {
          path: '/redes',
          component: Redes
        }
      ]
    },
    {
      path: '/about',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
    }
  ]
})

// router.beforeEach((to, from, next) => {
//   let verificarLocalStorage = false
//   if (localStorage.getItem('dispositivoAutenticado')) {
//     verificarLocalStorage = true
//   }

//   if (to.path === '/' || verificarLocalStorage) {
//     next()
//   } else {
//     location.replace('/')
//   }
// })

export default router
